import Vue from 'vue'
import VueOnToast from 'vue-on-toast'

const state = {}
const mutations = {}
const actions = {

    notify({}, payload)
    {
        const defaults = {
            type: 'info',
            title: '',
            message: '',
        }
        payload.message = payload.message ? Vue.prototype.$t(payload.message) : payload.native_message
        payload.title = payload.title ? Vue.prototype.$t(payload.title) : payload.native_title
        const toast = Object.assign({}, defaults, payload)
        VueOnToast.ToastService.pop(toast.type, toast.title, toast.message)
    },

}
const getters = {}

export default {
    state,
    mutations,
    actions,
    getters,
}


// WEBPACK FOOTER //
// ./src/store/modules/notifications/index.js